/**
 * External dependencies
 */
import { registerPlugin } from '@wordpress/plugins';

const render = () => {};

registerPlugin('woocommerce-wholesale-pricing', {
	render,
	scope: 'woocommerce-cart',
});
